import BaseService from '@/services/base_service';

export default class AcaoService extends BaseService {
    async list(params) {
        try {
            return await axios.get('/acao/pesquisa', {
                params: params
            });
        } catch (e) {
            throw e;
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/action.js